import { Button, MenuItem, SelectChangeEvent } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, Suspense, useMemo } from "react";
import {
	COVERAGE,
	VEBToGeneralCoverageCodeType,
	VEB_TO_GENERAL_COVERAGE_CODE
} from "../../../../../../../constants/coverage";
import {
	AuthContext,
	EligibleDependentContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions, LazyPlanDisclaimer, VEBDisclaimer } from "../../../../../../shared";
import { Checkbox } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { VEBEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";

import "./shortTermDisabilityForm.css";
import {
	benefitenefitAmount,
	STDDependentsPlanDetails,
	STDPlanDetails
} from "../../../../../../../constants/stdPlanDetails";
import {
	Enrollment,
	EnrollmentCommonDetails,
	EnrollmentStandardDetails,
	VEBEnrollments,
	VEBEnrollmentSchema
} from "../../../../../../../types/enrollment.types";
import { getKemperCancerEligibleDependents } from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import {
	PaycheckFrequency,
	PaycheckSTDArrayFrequency,
	ShortTermDisabilityCoverageLevel,
	ShortTermDisabilityDependentPlanDetails,
	ShortTermDisabilityPlanCoverage,
	ShortTermDisabilityPlanDetails,
	STDAgeGroup,
	STDAgeGroups,
	STDEmployeeBenefitAmount,
	VEBPlan
} from "../../../../../../../types/plan.types";
import { calculateAge, calculateAgeGroupSTD } from "../../../../../../../constants/calculateAge";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import {
	generateActivateVEBEnrollmentPayload,
	generateShortTermDisabilityWaiveEnrollmentPayload
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { Member } from "../../../../../../../types/member.types";
import { api } from "../../../../../../../utils/api";
import { useHistory, useLocation } from "react-router-dom";
import VEBPlanHeader from "../../../../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../../../../utils/commonFunctions/date";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import EnrollmentDependencyDialog from "../dependencyDialog/EnrollmentDependencyDialog";
import { trackPromise } from "react-promise-tracker";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import { VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
	({ theme }) => ({
		border: `1px solid ${theme.palette.divider}`,
		"&:not(:last-child)": {
			borderBottom: 0
		},
		"&:before": {
			display: "none"
		}
	})
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(90deg)"
	},
	"& .MuiAccordionSummary-content": {
		marginLeft: theme.spacing(1)
	}
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: "1px solid rgba(0, 0, 0, .125)"
}));

const KemperShortTermDisabilityForm = ({
	VEBOpenEnrollment,
	dependents,
	getVEBEnrollmentInitData
}: VEBPlanFormProps): JSX.Element => {
	const [writingNumber, setWritingNumber] = useState(1408);
	const [maxBenefitAmounts, setMaxBenefitAmounts] = useState<number[]>([]);
	const [shortTermDisabilityPlanDetails, setShortTermDisabilityPlanDetails] =
		useState<ShortTermDisabilityPlanDetails>(STDPlanDetails);
	const [shortTermDisabilityPlanInput, setShortTermDisabilityPlanInput] = useState<{
		coverage: null | string;
		benefit: null | string;
		benefit_amount: null | number;
	}>({
		coverage: null,
		benefit: null,
		benefit_amount: null
	});
	const [planDisclaimerChecked, setPlanDisclaimerChecked] = useState(false);
	const { paycheck } = useContext(PaycheckContext);
	const { member } = useContext(AuthContext);
	const [memberAge, setMemberAge] = useState<number>(
		calculateAge(member?.date_of_birth === undefined ? new Date() : new Date(member?.date_of_birth))
	);
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [plan, setPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const [enrollmentDependencyDialogProps, setEnrollmentDependencyDialogProps] = useState({
		openDialog: false,
		content:
			"You have enrolled for disability coverage with your Accident Plan which prohibits you from electing Short-Term Disability coverage. To elect Short-Term Disability coverage, please waive your current disability rider on your Accident Plan.\n\n You are encouraged to review both plan benefits with a licensed benefits counselor so that you have an accurate understanding of how either policy would best serve you and your family",
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					setEnrollmentDependencyDialogProps(
						Object.assign({}, enrollmentDependencyDialogProps, { openDialog: false })
					);
					const step = urlSearchParams.get("step");
					history.push(`?step=${step}&stage=0`);
				}
			},
			{
				label: "Waive",
				name: "waive",
				callback: () => {
					history.push("?step=Accident&stage=1&from=ShortTermDisablity");
				}
			}
		]
	});
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const { eligiblity, setEligiblity } = useContext(EligibleDependentContext);
	const history = useHistory();
	const [waiveReason, setWaiveReason] = useState("");
	const [prevWritingNumber, setPrevWritingNumber] = useState(1408);
	const [showWritingNumberValidateButton, setShowWritingNumberValidateButton] = useState(false);
	const { theme } = useContext(ThemeContext);
	const [hasAccidentDisablityRider, setHasAccidentDisablityRider] = useState<boolean | null>(null);
	const [coverage_for, setCoverageFor] = useState("");
	const [plan_type, setPlanType] = useState("");
	const [premium_amount, setPremiumAmount] = useState(0);
	const [benefit_amount, setBenefitAmount] = useState(0);
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [total_premium_amount, setTotalPremiumAmount] = useState(0);
	const [showMember, setShowMember] = useState(false);
	const [showQuestions, setShowQuestions] = useState(false);
	const location = useLocation();
	const [max_benefit_member, setMaxBenefitMember] = useState<any>([]);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const { groupOwner } = useContext(GroupOwnerContext);

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// // console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// // console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.short_term_disability) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setPlan(Object.assign({}, _planPaylaod));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	const handleValidation = useCallback((): boolean => {
		const { coverage, benefit } = shortTermDisabilityPlanInput;
		if (coverage === null || benefit === null) {
			alert("Please fill all required fields");
			return false;
		}
		if (planDisclaimerChecked === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		return true;
	}, [isActivelyWorking, planDisclaimerChecked, shortTermDisabilityPlanInput]);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || VEBOpenEnrollment === null) {
			return;
		}

		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
			generateShortTermDisabilityWaiveEnrollmentPayload(
				plan,
				"Short Term Disability",
				"Short Term Disability",
				null,
				groupOwner,
				member,
				waiveReason,
				VEBOpenEnrollmentId as unknown as string,
				false
			);
		const VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};
		const response = await trackPromise(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		// console.log("response", response);
		if (response) {
			deleteCurrentEnrollment();
			getVEBEnrollmentInitData();
			const step = urlSearchParams.get("step");
			const from = urlSearchParams.get("from");
			if (from === "Accident") {
				alert("Succesfully waived Short Term Disability Plan");
				history.push(`?step=${from}&stage=1`);
			} else {
				history.push(`?step=${step}&stage=2`);
			}
		}
	}, [
		member,
		VEBOpenEnrollment,
		plan,
		groupOwner,
		waiveReason,
		VEBOpenEnrollmentId,
		deleteCurrentEnrollment,
		getVEBEnrollmentInitData,
		urlSearchParams,
		history
	]);

	const handleActivateButtonClick = useCallback(async () => {
		const isValid = handleValidation();
		// console.log("isValid", isValid);
		// console.log("stdPlan", plan);
		if (isValid === false) {
			return;
		}
		if (
			member &&
			shortTermDisabilityPlanInput.coverage &&
			shortTermDisabilityPlanInput.benefit_amount &&
			plan &&
			VEBOpenEnrollment &&
			paycheck
		) {
			// console.log("shortTermDisabilityPlanInput", shortTermDisabilityPlanInput);
			const VEBEnrollments: VEBEnrollments[] = [
				{
					plan: plan,
					premiumAmount: premium_amount,
					totalPremium: total_premium_amount,
					coverageCode:
						VEB_TO_GENERAL_COVERAGE_CODE[
							shortTermDisabilityPlanInput.coverage as keyof VEBToGeneralCoverageCodeType
						],
					benefitAmount: shortTermDisabilityPlanInput.benefit_amount as number,
					planName: "Short Term Disability",
					subPlan: shortTermDisabilityPlanInput.benefit
				}
			];
			const enrollmentSuccessFlag = true;
			const activateEnrollmentPromises: any[] = [];
			VEBEnrollments.forEach(async (VEBEnrollment: VEBEnrollments) => {
				const { plan, premiumAmount, totalPremium, coverageCode, benefitAmount, planName, subPlan } =
					VEBEnrollment;
				const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
					generateActivateVEBEnrollmentPayload(
						plan,
						groupOwner,
						member,
						benefitAmount,
						coverageCode,
						premiumAmount,
						eligibleDependents,
						planName,
						totalPremium,
						"Short Term Disability",
						subPlan,
						VEBOpenEnrollmentId as unknown as string,
						paycheck,
						writingNumber
					);
				const VEBEnrollmentPayload: VEBEnrollmentPayload = {
					standard_details: VEBEnrollmentStandardDetails,
					common_details: VEBEnrollmentCommonDetails,
					isRider: false
				};
				activateEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
			});
			const response = await Promise.all(activateEnrollmentPromises);
			if (response) {
				deleteCurrentEnrollment();
				getVEBEnrollmentInitData();
				const step = urlSearchParams.get("step");
				history.push(`?step=${step}&stage=2`);
			}
		}
	}, [
		VEBOpenEnrollment,
		VEBOpenEnrollmentId,
		deleteCurrentEnrollment,
		eligibleDependents,
		getVEBEnrollmentInitData,
		groupOwner,
		handleValidation,
		history,
		member,
		paycheck,
		plan,
		premium_amount,
		shortTermDisabilityPlanInput,
		total_premium_amount,
		urlSearchParams,
		writingNumber
	]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const handleSTDPlanChange = (event: SelectChangeEvent, dependentName: string | null) => {
		const { name, value } = event.target as HTMLSelectElement;
		setShortTermDisabilityPlanInput(
			Object.assign({}, shortTermDisabilityPlanInput, {
				[name]: value
			})
		);
		if (value !== "Employee Only") {
			setShowMember(true);
		} else {
			setShowMember(false);
		}
	};

	const handleWritingNumberChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target as HTMLInputElement;
			setWritingNumber(Number(value));
			if (Number(value) !== prevWritingNumber) {
				setShowWritingNumberValidateButton(true);
			} else {
				setShowWritingNumberValidateButton(false);
			}
		},
		[prevWritingNumber]
	);

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	const calculatePremium = useCallback(() => {
		const { coverage, benefit, benefit_amount } = shortTermDisabilityPlanInput;
		if (coverage && benefit && benefit_amount && paycheck) {
			const calculatePremiumAmount =
				shortTermDisabilityPlanDetails.benefit_amount[coverage as keyof ShortTermDisabilityPlanCoverage][
					benefit as keyof ShortTermDisabilityCoverageLevel
				][benefit_amount as keyof PaycheckSTDArrayFrequency][
					calculateAgeGroupSTD(memberAge) as keyof STDAgeGroups
				][paycheck.pay_frequency as keyof PaycheckFrequency];
			//const calculatePremiumAmount = 23;
			setPremiumAmount(calculatePremiumAmount ? calculatePremiumAmount : 0);
			setTotalPremiumAmount(calculatePremiumAmount ? calculatePremiumAmount : 0);
			// setCurrentEnrollment(
			// 	Object.assign(
			// 		{},
			// 		{
			// 			plan_name: "Short Term Disability",
			// 			status: "Current",
			// 			premium_amount: Number((calculatePremiumAmount ? calculatePremiumAmount : 0).toFixed(2))
			// 		}
			// 	)
			// );
		}
	}, [memberAge, paycheck, shortTermDisabilityPlanDetails.benefit_amount, shortTermDisabilityPlanInput]);

	const getAccidentDisablityRiderEnrollment = useCallback(async () => {
		const accidentDisablityRiderEnrollment: VEBEnrollmentSchema | null =
			await api.enrollment.getAccidentDisablityRiderEnrollment();
		if (accidentDisablityRiderEnrollment) {
			setHasAccidentDisablityRider(true);

			setEnrollmentDependencyDialogProps((prevEnrollmentDependencyDialogProps: any) => {
				return Object.assign({}, prevEnrollmentDependencyDialogProps, {
					openDialog: true
				});
			});
		}
	}, []);

	const getMaxBenefitAmounts = useCallback(() => {
		if (paycheck) {
			let maxBenefitAmount = 0;
			// console.log("TE: ", paycheck.rate_type);
			switch (paycheck.rate_type) {
				case "FLAT RATE": {
					if (paycheck.pay_frequency === "MONTHLY") {
						const annualSalary = paycheck.monthly_base_rate * 12;
						const annualMaxBenefit = annualSalary * 0.6;
						const weeklySalary = annualMaxBenefit / 52;
						maxBenefitAmount = Math.floor(weeklySalary / 50) * 50;
					} else if (paycheck.pay_frequency === "WEEKLY") {
						const annualSalary = paycheck.weekly_base_rate * 52;
						const annualMaxBenefit = annualSalary * 0.6;
						const weeklySalary = annualMaxBenefit / 52;
						maxBenefitAmount = Math.floor(weeklySalary / 50) * 50;
					}
					break;
				}
				case "HOURLY RATE": {
					if (paycheck.pay_frequency === "MONTHLY") {
						const annualSalary = paycheck.hourly_base_pay_rate * 160 * 12;
						const annualMaxBenefit = annualSalary * 0.6;
						const weeklySalary = annualMaxBenefit / 52;
						maxBenefitAmount = Math.floor(weeklySalary / 50) * 50;
					} else if (paycheck.pay_frequency === "WEEKLY") {
						const annualSalary = paycheck.hourly_base_pay_rate * 40 * 52;
						const annualMaxBenefit = annualSalary * 0.6;
						const weeklySalary = annualMaxBenefit / 52;
						// console.log("weekly", weeklySalary);
						maxBenefitAmount = Math.floor(weeklySalary / 50) * 50;
					}
				}
			}
			//alert(maxBenefitAmount);
			//const annualSalary = paycheck.hourly_base_pay_rate * 160 * 12;
			//const maxBenefitAmount = Math.floor((annualSalary * 0.6) / 100) * 100;
			const _maxBenefitAmounts: number[] = [];
			benefitenefitAmount.forEach((benefitAmount: number) => {
				if (benefitAmount <= maxBenefitAmount) {
					_maxBenefitAmounts.push(benefitAmount);
				}
			});
			setMaxBenefitAmounts(Object.assign([], _maxBenefitAmounts));
		}
	}, [paycheck]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	useEffect(() => {
		calculatePremium();
		max_benefit_member.length > 0 ? setShowQuestions(true) : setShowQuestions(false);
	}, [coverage_for, plan_type, benefit_amount, max_benefit_member, calculatePremium]);

	useEffect(() => {
		getMaxBenefitAmounts();
		getAccidentDisablityRiderEnrollment();
	}, [getAccidentDisablityRiderEnrollment, getMaxBenefitAmounts]);

	return (
		<Suspense fallback={<div />}>
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<Suspense fallback={<div />}>
				<EnrollmentDependencyDialog dialogProps={enrollmentDependencyDialogProps} />
			</Suspense>
			<div className="kemper-cancer-form plan-form">
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						<VEBPlanHeader
							planName="MedMutual Protect Short Term Disability Insurance Policy"
							effectiveDate={
								planCode
									? planCode === "STD-ALL-2024"
										? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
										: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
									: "N/A"
							}
							planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
						/>
						<div className="plan-content">
							<div className="theme-plan-section-margin" />
							<div className="header-container header-container-new">
								<div className="theme-plan-header">Standard Benefits</div>
							</div>
							<div>
								<div
									className="theme-plan-sub-header plan-text"
									style={{ borderLeftColor: theme.primary_color }}
								>
									In addition to yourself, who would you like to cover under this plan?
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Coverage For</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="coverage"
												onChange={(event: SelectChangeEvent) =>
													handleSTDPlanChange(event, null)
												}
											>
												<MenuItem value="Employee Only">Employee Only</MenuItem>
											</Select>
										</div>
									</Grid>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Benefit</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="benefit"
												onChange={(event: SelectChangeEvent) =>
													handleSTDPlanChange(event, null)
												}
											>
												<MenuItem value="Non-Occupational(Elim Period accident: 0 Sickness: 7 Benefit Period: 6 Months)">
													Non-Occupational(Elim Period accident: 0 Sickness: 7 Benefit Period:
													6 Months)
												</MenuItem>
												<MenuItem value="Non-Occupational(Elim Period accident: 14 Sickness: 14 Benefit Period: 6 Months)">
													Non-Occupational(Elim Period accident: 14 Sickness: 14 Benefit
													Period: 6 Months)
												</MenuItem>
											</Select>
										</div>
									</Grid>

									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Benefit Amount</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="benefit_amount"
												onChange={(event: SelectChangeEvent) =>
													handleSTDPlanChange(event, null)
												}
											>
												{maxBenefitAmounts.map((benefitAmount, index) => {
													return (
														<MenuItem key={index} value={benefitAmount}>
															{benefitAmount.toFixed(2)}
														</MenuItem>
													);
												})}
											</Select>
										</div>
									</Grid>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
									<Grid item xl={2} lg={2} md={2} sm={2} xs={6} className="amount-middle">
										<div className="details-form-row handle-three-row-premium">
											<div className="details-form-label required align-center">Premium</div>
											<div className="show-premium">
												{premium_amount == 0 ? "$0.00" : `$${premium_amount.toFixed(2)}`}
											</div>
										</div>
									</Grid>
								</Grid>
							</div>
						</div>
						<div className="theme-plan-inner-section-margin" />
						<Grid container className="theme-plan-inner-section-margin">
							<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
								<div className="details-form-row">
									<div
										className="details-form-label theme-plan-total-premium align-right"
										style={{ color: theme.primary_color }}
									>
										Total Premium:{" "}
										<span className="show-premium margin-adjust">
											{total_premium_amount == 0
												? "$0.00"
												: `$${total_premium_amount.toFixed(2)}`}
										</span>
									</div>
								</div>
							</Grid>
						</Grid>
						{!VEBPlanCodes2024.includes(planCode as unknown as string) ? (
							<div className="veb-disclaimer">{/* <VEBDisclaimer /> */}</div>
						) : null}
						<div className="theme-plan-option-content">
							<Checkbox
								checked={isActivelyWorking}
								style={{ paddingLeft: 0 }}
								onChange={handleIsActivelyWorkingCheckboxChange}
							/>
							<p className="theme-plan-checkbox-label">
								<strong>Are you actively at work 20 or more hours per week?</strong>
							</p>
						</div>
						<div>
							<LazyPlanDisclaimer
								planDisclaimerChecked={planDisclaimerChecked}
								setPlanDisclaimerChecked={setPlanDisclaimerChecked}
							/>
						</div>
						{/* <Grid container>
							<Grid item xl={4} lg={4} md={4} sm={4} xs={10} columnSpacing={2}>
								<div className="details-form-row">
									<div className="details-form-label required">Writing Number</div>
									<Grid container>
										<Grid item xl={9}>
											<CustomInput value={writingNumber} onChange={handleWritingNumberChange} />
										</Grid>
										{showWritingNumberValidateButton ? (
											<Grid item xl={3}>
												<div className="writing-number-validate-container">
													<Button
														style={{
															backgroundColor: theme.button.background_color,
															color: theme.button.color,
															opacity: 0.8
														}}
													>
														Validate
													</Button>
												</div>
											</Grid>
										) : null}
									</Grid>
								</div>
							</Grid>
						</Grid> */}

						<div className="theme-plan-inner-section-margin-2" />
						<LazyPlanActions
							waiveButtonCallback={handleWaiveButtonClick}
							activateButtonCallback={handleActivateButtonClick}
						/>
					</Paper>
				</div>
			</div>
		</Suspense>
	);
};

export default KemperShortTermDisabilityForm;
